import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=d5270774"
import script from "./ReportsTable.vue?vue&type=script&lang=ts"
export * from "./ReportsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports